import React from 'react'
import { RouteComponentProps } from 'react-router'
import { SearchFilterProvider } from 'views/providers'
import SegmentsProvider from '../SegmentsProvider'
import SegmentsPage from './SegmentsPage/SegmentsPage'
import SegmentFocusMode from './SegmentFocusMode/SegmentFocusMode'

const SegmentsRoute = ({ location }: RouteComponentProps): React.ReactElement => (
  <SegmentsProvider>
    <SearchFilterProvider location={location}>
      <SegmentsPage />
    </SearchFilterProvider>
    <SegmentFocusMode />
  </SegmentsProvider>
)

export default SegmentsRoute
